import { render } from "./BrandAnalytics.vue?vue&type=template&id=07a7c8b0&scoped=true"
import script from "./BrandAnalytics.vue?vue&type=script&lang=js"
export * from "./BrandAnalytics.vue?vue&type=script&lang=js"

import "./BrandAnalytics.vue?vue&type=style&index=0&id=07a7c8b0&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a7c8b0"]])

export default __exports__